export default (params) => ({
  trigger: {
    name: 'feedback_element.show',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'ar',
          'after_order',
          'trade-in',
          'return',
          'article',
          'other',
          'advice',
        ],
      },
    },
    event: {
      name: 'show_content',
    },
    nonInt: true,
  },
});
